var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalanceL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 189,
    viewBox: "0 0 113 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59006 130.19C3.65039 129.416 2.3238 129.527 1.43941 128.643C0.665561 130.024 0.941934 130.577 2.04743 131.406C3.87149 132.788 5.86138 132.733 7.74071 132.235C10.6703 131.406 13.3787 132.18 16.1425 132.954C23.7704 135.165 31.3983 137.376 39.0814 139.476C41.016 140.029 43.0059 140.582 44.9958 141.19C44.6089 142.461 44.7747 143.733 44.7747 145.004C44.83 146.552 44.7194 148.099 44.1114 149.536C43.9456 149.979 43.8903 150.31 44.2772 150.587C44.7194 150.974 45.1064 150.808 45.4933 150.476",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3976 101.945C52.7343 103.714 53.6187 105.262 54.1162 106.865C54.282 107.528 54.5031 108.191 54.282 108.744C52.9554 113.221 53.674 117.754 53.9503 122.286C54.0609 124.497 54.0056 126.598 52.9554 128.477C51.9605 130.301 52.2921 132.125 52.3474 133.949C52.4027 135.165 52.6238 136.437 52.679 137.653C52.679 137.984 52.5685 138.371 52.2368 138.758C51.5183 139.532 51.2419 140.638 51.463 141.632C51.8499 143.678 51.7394 145.778 52.4027 147.768C52.7343 148.763 52.0157 149.868 51.9052 150.919",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1819 67.1769C42.6743 67.5638 44.1667 67.4533 45.5486 67.0111C47.3726 66.4031 49.1967 66.5689 50.8549 67.1217C54.2267 68.2824 57.4879 67.6744 60.8044 66.9558C63.8998 66.2925 66.774 67.2322 68.9298 69.3879C70.0352 70.4381 69.5378 72.3175 69.2614 73.8099C68.8745 75.855 67.769 77.6238 67.2715 79.669C66.5529 82.5433 65.7238 85.3623 64.8947 88.1813C64.1761 90.5028 64.3972 92.8796 64.3972 95.2012C64.3972 96.3619 64.0656 97.3569 63.1812 97.9649C62.0757 98.6282 61.9651 99.6231 62.0204 100.673C62.131 103.492 61.8546 106.311 62.4626 109.186C63.1812 112.557 62.2968 115.874 61.136 119.135C60.0858 121.954 58.8698 124.718 57.9854 127.592C57.5432 129.085 57.2668 130.466 57.7643 131.959C58.1512 133.12 58.0406 134.391 58.5381 135.552C58.925 136.436 59.312 137.265 60.2516 137.707C60.9149 137.984 60.8044 138.868 61.1913 139.421",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.431 131.296C99.1648 132.346 96.6775 132.788 94.2454 133.507C89.1049 135.055 83.909 136.436 78.7132 137.929C72.7988 139.587 66.8845 141.301 60.9148 142.959",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6843 96.252C42.7848 98.7946 42.9506 101.89 42.5637 104.875C42.0662 109.02 41.8451 113.111 42.1215 117.201C42.4531 121.291 43.2822 125.326 44.3325 129.306C45.1063 132.236 45.3274 135.276 45.5485 138.316C45.6038 139.256 45.4379 140.14 44.9957 140.969",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.878 129.416C91.9791 131.959 83.0799 134.446 74.2359 136.989C70.035 138.205 65.8342 139.365 61.6333 140.581",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.132 46.5049C28.7451 49.2133 27.6949 51.756 27.308 54.4644C26.4236 60.6552 26.5341 66.8459 26.7552 73.0367C26.8658 75.303 26.921 77.5692 26.8658 79.7802C26.8658 81.0515 26.4236 82.2676 25.8708 83.3178C25.2075 84.6997 25.5392 85.9157 25.8155 87.187C25.9261 87.5739 25.7603 87.9056 26.0919 88.4031C24.7653 88.0161 24.8759 86.9659 24.5995 86.1368C24.3231 85.4182 24.4337 84.9208 25.2628 84.6997",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8391 41.9717C77.4973 45.9515 79.1556 49.8207 81.0902 53.6899C82.0298 55.5692 82.1404 57.8355 82.6931 59.8807C83.7986 63.7499 84.3514 67.7297 85.1252 71.7094C85.4016 73.2571 86.3413 74.4732 87.0046 75.7998C87.7784 77.3474 87.502 78.066 86.6729 79.4479C86.0649 80.4428 85.1252 81.0508 84.6277 82.0458C84.3514 82.5433 84.075 82.8196 83.467 82.8749C82.472 82.9855 82.1957 84.0357 81.5876 84.8095C81.1454 84.2015 81.0902 83.7593 81.4771 83.096C81.9193 82.3774 82.2509 81.5483 82.5273 80.7192C82.9695 79.4479 82.3062 77.5133 81.2007 76.7394C80.3163 76.0761 79.8741 76.2972 79.3214 77.2369C79.1003 77.6238 79.1003 78.1766 78.5475 78.4529C78.2712 78.6188 77.9948 78.7846 77.7184 78.674C77.3868 78.5635 77.3868 78.2318 77.442 77.9002C77.7737 76.0209 77.9948 74.1415 79.4319 72.7596C80.3163 71.9305 80.2058 71.0461 79.8189 70.1065C78.6028 67.3427 77.1657 64.6896 75.8944 61.9811C74.623 59.1621 73.407 56.2325 72.9648 53.1372C72.8543 52.2528 72.5226 51.4789 71.9699 50.9262C70.8644 49.7654 70.1458 48.3835 69.3719 47.0569",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2252 129.14C94.5771 130.19 90.8737 131.295 87.2256 132.346C81.8639 133.838 76.5023 135.386 71.1959 136.878C68.1558 137.707 65.1157 138.592 62.0204 139.365C61.6887 139.476 61.4676 139.531 61.2465 139.752C61.4676 140.36 61.6334 140.968 61.9098 141.908C59.9199 141.908 58.1511 141.853 56.3271 141.908C54.8899 141.963 53.4528 141.632 52.0709 142.184",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1916 105.151C50.1363 106.478 50.6891 107.749 51.0207 108.965C51.7393 111.674 51.684 114.493 51.7946 117.201C51.9051 119.191 51.3524 121.292 50.9654 123.281C50.7443 124.387 50.6891 125.548 50.6338 126.598C50.5232 129.141 50.081 131.683 50.2469 134.281C50.3021 134.944 50.4127 135.552 50.7443 136.16C51.1865 136.934 51.2971 137.929 51.5735 138.814",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5487 24.2295C43.2271 26.0536 40.5739 27.4354 37.8102 28.5409C35.2123 29.6464 33.4435 31.3599 31.9511 33.7367C30.4034 36.2241 30.2376 38.9878 29.4085 41.641C28.9663 42.9676 28.4688 44.2942 28.303 45.676C30.7903 47.6107 33.6646 48.3292 36.6494 48.8267",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5496 129.692C13.9314 130.522 15.5344 130.687 17.0821 131.13C24.9864 133.396 32.8906 135.662 40.8502 137.873C42.3979 138.315 43.8903 138.923 45.4932 139.089",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4987 58.167C33.0565 59.0514 33.6093 59.9358 33.6645 60.8202C33.7751 63.4181 33.0565 65.9054 32.5038 68.3928C31.7299 71.5435 31.343 74.8047 31.6747 78.0659C31.7852 79.2266 32.6696 80.0005 32.946 81.106C33.1118 81.8245 33.3329 82.4878 32.8907 83.0958C32.2274 84.0908 32.1721 85.3068 31.8405 86.4676C30.9008 86.3018 30.7903 85.6385 30.735 84.8646C30.735 84.3119 30.8455 83.7591 30.4586 83.2617",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7744 23.2891C58.8698 24.5051 61.9652 25.887 65.1711 26.7714C69.0403 27.8216 71.1408 30.7511 72.5779 34.1782C73.2412 35.7259 74.2914 36.9972 75.1758 38.379C76.5577 40.5347 76.0049 41.585 74.4572 43.1327C72.9648 44.5698 71.2513 45.8411 69.3167 46.7808C68.5981 47.1124 67.9348 46.8913 67.0504 46.0069",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6538 187.399C56.3825 188.284 55.1111 187.565 53.7845 187.62C53.8398 186.736 53.8951 185.907 53.8951 185.133C53.9504 176.621 54.0056 168.053 54.0056 159.541C54.0056 159.154 53.9504 158.767 54.0056 158.325C54.1162 157.164 54.5584 156.832 55.6086 156.888C56.6588 156.943 57.0457 157.606 57.0457 158.491C57.101 160.204 57.1563 161.918 57.1563 163.686C57.2116 170.54 57.709 177.394 57.709 184.249C57.709 185.243 57.9854 186.183 57.709 187.178",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.589 68.2832C37.1468 68.6149 37.0915 69.1676 36.6493 69.4992C35.1569 70.6047 35.2122 72.0972 35.7097 73.5896C36.3177 75.3584 37.2574 77.0166 37.6443 78.7854C38.5287 83.2626 38.9156 87.7951 37.6443 92.2724C37.3679 93.2673 37.589 94.207 38.1418 94.7598C39.0262 95.6441 39.8 96.5838 40.5186 97.5788C40.6844 97.7999 41.016 97.7446 41.2924 97.5788",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3274 138.04C41.2371 136.934 37.2021 135.829 33.1117 134.723C28.2476 133.397 23.3834 131.96 18.5192 130.633C18.464 130.633 18.4087 130.522 18.4087 130.522",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6035 14.39C56.5482 14.0031 56.6035 13.5609 56.8798 13.3398C58.8697 11.9026 58.1512 9.96803 57.8748 8.14397C57.7642 7.53595 57.7642 7.31485 58.2617 7.03847C57.4879 6.48573 56.9904 5.76716 56.4929 4.93804C55.3322 3.16925 53.7845 1.84266 51.7393 1.23464C48.4228 0.350244 44.222 2.00848 43.2823 5.49078C43.227 5.71188 43.1165 5.98826 42.7848 6.20936C40.7397 7.59122 40.408 9.80221 41.5135 12.179C41.9004 12.9529 42.3426 13.8925 42.011 14.9427C41.7346 15.9377 42.2873 16.9326 42.6743 17.817C42.8954 18.3145 43.3928 18.7567 44.1114 18.3698",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6635 155.285C64.3419 155.562 61.9651 155.562 59.6436 155.617C56.714 155.727 53.7845 156.004 50.9102 155.948C48.5334 155.893 46.1566 156.391 43.7245 156.225",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9258 48.8809C37.6996 51.534 37.4785 54.2978 37.8654 56.951C38.1971 59.1067 38.1418 61.2624 38.1418 63.4734C38.1418 64.6894 37.9207 65.7396 37.0363 66.6793C38.0865 68.6139 38.9157 68.7797 40.7397 67.3426C41.9558 66.4029 43.0613 65.2974 44.609 64.8",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6238 90.8345C52.0711 89.5079 51.0208 89.1762 49.6942 89.0657C48.4782 88.9551 47.3174 88.734 46.1014 88.8446C43.3929 89.0657 41.0161 90.0053 39.3026 92.2716C38.7499 92.9902 38.3629 93.6535 38.9157 94.5379C39.0262 94.7037 38.8604 94.9801 38.8051 95.2012",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4878 24.2295C57.0456 26.2747 56.1612 28.0434 54.3372 29.3148C51.076 31.581 45.9907 30.4755 44.6641 26.4958C44.5536 26.1641 44.5536 25.8325 44.2219 25.5561",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.764 35.3389C68.5429 37.2182 67.9348 39.0423 67.5479 40.9216C67.161 42.9115 67.1057 44.9014 66.7741 46.8913C66.553 48.2731 66.4424 49.7655 65.4475 50.871C63.7892 52.6951 64.2867 54.7955 65.0053 56.6749C65.6133 58.2778 66.1108 59.715 65.2264 61.3732C65.0606 61.7049 65.2264 62.2576 65.0606 62.6998",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M111.491 128.366C109.888 127.813 108.23 127.924 106.572 127.703C104.969 127.481 103.311 127.205 101.652 127.205C99.9388 127.205 98.2253 127.371 96.6223 128.089",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5294 128.366C14.4842 127.758 12.4391 127.427 10.2834 127.703C7.51963 128.09 4.70062 128.145 1.93689 128.643",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9459 34.2891C34.7147 36.9975 36.0413 39.9271 36.4282 43.1883C36.6493 44.9571 36.4835 46.7811 36.9257 48.4946C36.7599 48.4946 36.8704 48.8263 36.6493 48.771",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2668 159.154C58.925 158.878 60.6385 159.099 62.2968 158.933C63.8997 158.767 65.558 158.988 67.3267 158.712C67.3267 156.114 66.6082 153.848 65.5027 151.637C65.2263 151.139 64.8947 151.195 64.563 151.25C61.744 151.747 58.8697 151.305 56.0507 151.526C53.895 151.692 51.7946 151.637 49.6941 151.526C48.3123 151.416 46.7646 151.747 45.3274 151.913C45.1616 151.913 45.0511 151.913 44.8852 152.189C44.0009 154.069 43.1717 155.893 43.6139 158.049C43.7245 158.601 43.6692 159.154 43.7798 159.817C47.2068 159.541 50.5785 159.486 53.9503 159.375",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9302 12.9521C59.1462 13.8918 58.9251 15.2737 58.8146 16.545C58.7593 17.3188 57.9855 17.761 57.2669 17.8716C56.7694 17.9269 56.7694 18.148 56.7141 18.5349C56.5483 20.2484 56.2719 21.9619 55.5534 23.5649C55.2217 24.2834 55.9956 25.002 55.7745 25.8311",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6841 90.0059C51.4077 92.8249 51.5183 95.5886 52.071 98.3523C52.2368 99.2367 52.3474 100.176 52.1263 101.006C51.9605 101.945 52.2368 102.443 52.9554 102.885",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9601 94.5385C62.2415 92.825 60.528 92.5486 59.0908 92.0512C57.1562 91.3326 55.0558 91.3326 53.0106 91.6642C52.7895 91.7195 52.6237 91.5537 52.4579 91.609",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8651 9.24884C47.5938 9.69103 46.5436 8.91719 45.1617 8.80664C43.2824 9.63576 43.9457 11.6256 43.6693 13.2286C43.0613 16.6004 44.4984 19.6405 45.2723 22.7911C45.6039 24.0624 45.8803 25.389 46.1567 26.6603",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2769 24.0625C54.9453 24.2283 54.89 24.56 54.7242 24.8363C53.2317 27.6001 50.0258 28.1528 47.7043 26.0524C47.1515 25.5549 46.7646 24.9469 46.1013 24.6152",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9803 72.4834C56.106 74.3075 53.8397 76.6843 52.292 79.7796C51.9051 80.5535 51.9604 81.2168 51.9604 81.9354C51.9604 82.4328 52.1262 82.9303 52.0157 83.3725C51.6287 84.7544 52.2367 85.8599 52.8448 86.9653C53.7292 88.6236 53.3975 90.2266 51.7946 91.9953",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5388 48.8809C35.5991 51.921 35.0464 55.0716 33.6093 57.8906",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5295 128.643C15.7556 129.085 14.8712 129.029 13.9868 129.14C11.9969 129.472 9.8965 129.472 7.90662 129.803C7.35387 129.914 6.74585 129.969 6.1931 129.969C5.19816 129.969 4.53486 130.356 4.70069 131.572C4.75596 131.849 4.70069 132.125 4.70069 132.346",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5017 129.03C99.3308 128.422 100.215 128.864 100.989 129.085C101.542 129.251 101.597 129.859 101.542 130.356C101.431 131.02 101.763 131.517 102.371 131.517C104.416 131.517 106.406 132.291 108.451 132.07",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2928 82.3223C29.0215 84.1463 27.8608 85.9704 29.1874 88.2919C29.5743 88.9552 29.7401 89.9502 29.3532 90.7793",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2061 69.7203C67.4926 70.2178 66.0002 69.3334 64.4525 69.0571C63.2364 68.836 62.0757 68.3938 60.8596 68.0068",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7144 71.4336C47.262 73.4788 49.1967 75.137 50.468 77.4033C50.6891 77.8455 51.076 78.1771 51.0207 78.7298",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M111.491 128.643C109.17 130.024 106.682 129.638 104.195 129.306C103.255 129.195 102.371 128.808 101.431 129.195",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1421 83.3721C27.1421 83.4273 27.1421 83.4826 27.1421 83.4826C26.5894 85.7489 26.8658 87.8493 28.3029 89.7287C28.3582 89.7839 28.2476 90.005 28.1923 90.1156",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7241 142.13C54.6136 144.783 54.4478 147.436 54.3372 150.089C54.3372 150.532 54.2267 150.974 54.4478 151.416",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8651 15.4404C49.4731 17.1539 49.5284 18.8675 49.252 20.6362C49.5284 21.1337 50.1364 20.6915 50.4681 21.0232",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6501 129.417C15.7004 130.025 16.9164 129.914 17.9666 130.522C18.4641 129.914 18.1324 129.306 18.243 128.754C17.635 128.532 17.2481 128.422 16.7506 128.422",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7141 142.13C56.6035 145.115 57.1563 148.155 56.9905 151.14",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1855 76.7393C83.9644 77.1262 84.0196 77.5684 84.0749 77.9553C84.296 79.6135 84.0749 81.2165 83.4116 82.7089",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9301 76.7393C55.7744 77.7342 54.1714 79.5583 52.2368 80.8296",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7346 69.0566C39.8553 69.3883 38.1417 70.4385 36.1519 70.4938",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0507 14.1126C55.9401 12.5096 55.5532 11.0172 54.7241 9.58006C54.4477 9.08259 53.895 8.69567 53.5633 8.97204C52.0709 9.91171 50.6338 9.13787 49.1414 9.08259",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M112.154 128.753C112.652 130.024 112.154 130.853 110.938 131.24C110.109 131.517 109.446 132.18 108.562 132.18",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6939 142.02C60.6939 142.904 60.6939 143.788 60.6939 144.783C59.3673 144.783 58.1512 144.783 56.9905 144.783",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9595 75.9658C85.2911 77.6241 85.5122 79.2823 85.2358 80.9958",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9907 75.4131C47.7042 76.4633 49.0308 77.9557 50.9102 78.7296C51.2971 78.8954 51.5182 79.3929 51.7393 79.7798",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4684 92.6592C39.6895 93.8199 40.0211 94.9254 40.5739 95.9204C40.3528 96.3073 40.0764 96.252 39.7448 96.252",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9605 102.497C51.3525 103.768 51.2972 105.15 50.9103 106.477",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7542 107.252C59.4778 107.252 59.2014 107.473 59.1462 107.528C58.1512 108.523 57.0457 108.579 55.7744 108.026",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7343 138.813C52.9554 139.145 53.0659 139.532 53.2317 139.864C54.0056 141.301 54.1714 141.356 55.498 140.361",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9602 64.0264C64.5632 64.8555 66.1661 65.7399 67.6033 66.7348C67.7691 67.2323 67.2163 67.4534 67.2163 67.8403",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4879 187.124C56.493 185.687 55.277 186.184 54.0609 186.737",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8148 15.2188C46.8199 14.5555 45.7144 14.7213 44.6089 14.666",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7886 75.9658C86.8388 76.9055 86.2308 78.1768 86.5624 79.2823",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9099 59.7695C63.3471 61.5936 65.1711 63.0307 67.3268 64.081C67.0505 64.7442 66.7741 65.297 66.553 65.905",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4477 14.1133C53.3975 14.1133 52.4025 14.5002 51.4076 14.7766",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5586 102.773C44.6088 103.989 45.1063 104.1 46.4881 103.547",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2253 128.642C97.7278 128.311 97.1751 128.366 96.6223 128.256C95.0194 127.979 94.9641 128.09 95.2958 129.858",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1916 148.376C50.1916 149.316 49.1414 150.089 49.6389 151.14",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M47.041 148.652C46.4882 149.205 46.8199 150.034 46.4329 150.642C44.7194 150.421 45.3827 149.26 45.438 148.376",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0709 22.9014C51.1865 22.9566 50.3021 23.0119 49.4177 23.0119",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3371 144.949C53.5633 144.949 52.7342 144.949 51.9603 144.949",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2024 88.6787C26.5893 89.0656 26.5893 89.7842 27.3632 89.8948C28.0817 90.0053 28.6345 90.5581 29.2425 91.0555",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7546 148.541C48.4229 149.204 47.7596 149.757 47.9807 150.641",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M108.451 129.804C108.783 130.578 108.451 131.407 108.562 132.181",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9503 16.6553C53.2317 16.8211 52.5684 17.0975 51.8499 17.0422",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8863 129.692C11.6099 130.356 11.831 131.019 11.7758 131.682",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7241 138.316C55.0005 139.201 55.3321 140.03 56.2165 140.693C56.9904 139.809 57.9853 139.201 58.7592 138.648C58.925 137.874 58.2064 137.763 58.1512 137.321",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0707 94.8154C63.5682 95.4787 63.4576 96.142 62.9049 96.6395C62.4074 97.137 62.0758 97.6344 62.4074 98.353",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7942 94.8154C62.5178 95.4235 62.6836 96.0315 62.6836 96.6948",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7541 6.9834C59.3119 7.53614 58.7039 7.2045 58.1511 7.25977",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4076 8.14453C51.8498 8.642 52.6236 8.53145 53.1211 8.91838",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7744 138.039C56.1613 138.592 56.5483 139.2 56.9905 139.753",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42.011 10.4102C42.011 10.9629 42.0663 11.5156 41.7346 12.0131",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M47.428 7.64648C47.6491 8.36505 48.4782 8.42033 48.8651 8.97308",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1008 137.486C57.4325 137.984 57.7088 138.481 58.0405 138.923",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7646 150.642C47.3174 151.36 48.2571 150.365 48.7545 151.194",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2971 83.3721C51.2418 83.8695 51.6287 84.2012 51.8498 84.5881",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6035 6.9834C56.9352 7.14922 57.3221 7.31505 57.6537 7.53614",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M42.398 97.0254C42.1216 97.3018 42.4532 97.6887 42.1216 97.9651",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3979 14.3906C42.7296 14.667 42.8954 15.0539 43.3376 15.1645",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5485 16.7666C46.267 16.9324 46.9303 17.2088 47.6489 17.1535",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceL);
export default __webpack_public_path__ + "static/media/balance-l.58e9c9015639c36a582fdc8c8d700b57.svg";
export { ForwardRef as ReactComponent };